import React from 'react'
import styled from 'styled-components'

import Button from '../../Button'
import ButtonGroup from '../../ButtonGroup'
import { AnyObject } from '../types'

interface RowControlProps {
  controls: AnyObject[]
}

const Wrapper = styled.div``

const RowControls = (props: RowControlProps): React.ReactElement => {
  const { controls = [] } = props

  return (
    <Wrapper className="d-flex justify-content-end">
      <ButtonGroup nowrap size="sm">
        {controls.map((control, key) => (
          <Button {...control} key={key} />
        ))}
      </ButtonGroup>
    </Wrapper>
  )
}

export default RowControls
